import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const LockOpenIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M11.5996 17.1992C12.6996 17.1992 13.5996 16.2992 13.5996 15.1992C13.5996 14.0992 12.6996 13.1992 11.5996 13.1992C10.4996 13.1992 9.59961 14.0992 9.59961 15.1992C9.59961 16.2992 10.4996 17.1992 11.5996 17.1992ZM17.5996 8.19922H16.5996V6.19922C16.5996 3.43922 14.3596 1.19922 11.5996 1.19922C8.83961 1.19922 6.59961 3.43922 6.59961 6.19922H8.49961C8.49961 4.48922 9.88961 3.09922 11.5996 3.09922C13.3096 3.09922 14.6996 4.48922 14.6996 6.19922V8.19922H5.59961C4.49961 8.19922 3.59961 9.09922 3.59961 10.1992V20.1992C3.59961 21.2992 4.49961 22.1992 5.59961 22.1992H17.5996C18.6996 22.1992 19.5996 21.2992 19.5996 20.1992V10.1992C19.5996 9.09922 18.6996 8.19922 17.5996 8.19922ZM17.5996 20.1992H5.59961V10.1992H17.5996V20.1992Z"
            fill="#222"
          />
        </svg>
      </IconWrapper>
    )
  },
)
